/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Plc_Maintenance_DurationInputs */



/**
* | output |
* | --- |
* | "During" |
*
* @param {Module_Settings_Plc_Maintenance_DurationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_plc_maintenance_duration = /** @type {((inputs?: Module_Settings_Plc_Maintenance_DurationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Plc_Maintenance_DurationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("During")
	return /** @type {LocalizedString} */ ("Pendant")
});